const styles = theme => ({
    container: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },
});

export default styles;
